import React from 'react'

// By throwing the error in a setState function we trick React
// into catching the async error like it would any other error in a component
const useAsyncError = () => {
    const [, genericSetStateFunction] = React.useState()
    return React.useCallback(
        error => {
            genericSetStateFunction(() => {
                throw new CustomError(error)
            })
        },
        [genericSetStateFunction],
    )
}

class CustomError extends Error {
    constructor(errorOfUnknownType) {
        let status = 400
        let title = 'Unknown error'
        let detail = 'No details'

        if (errorOfUnknownType.toString() === 'TypeError: Failed to fetch') {
            status = 500
            title = 'Failed to connect to server'
            detail = 'TypeError: Failed to fetch'
        }
        if (errorOfUnknownType.status) {
            status = errorOfUnknownType.status
        }
        if (errorOfUnknownType.title) {
            title = errorOfUnknownType.title
        }
        if (errorOfUnknownType.detail) {
            detail = errorOfUnknownType.detail
        }

        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(`${status}: ${title}`)

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CustomError)
        }

        this.status = status
        this.title = title
        this.detail = detail
    }
}

export { useAsyncError, CustomError }